// Thin wrapper over v1's RatioModal that adds the externalOpen / onExternalClose
// pattern expected by the v2.0-based generate page.

import { useEffect, useState } from 'react';
import RatioModal from './RatioModal';

interface RatioSelectorProps {
  selectedRatio: string | null;
  onSelect: (ratioId: string) => void;
  externalOpen?: boolean;
  onExternalClose?: () => void;
  allowedRatioIds?: string[];
}

export default function RatioSelector({ selectedRatio, onSelect, externalOpen, onExternalClose, allowedRatioIds }: RatioSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (externalOpen) setIsOpen(true);
  }, [externalOpen]);

  const handleClose = () => {
    setIsOpen(false);
    onExternalClose?.();
  };

  const handleSelect = (ratioId: string) => {
    onSelect(ratioId);
    handleClose();
  };

  return (
    <RatioModal
      isOpen={isOpen}
      selectedId={selectedRatio}
      onClose={handleClose}
      onSelect={handleSelect}
      allowedRatioIds={allowedRatioIds}
    />
  );
}
